<template>
  <span v-if="dataSource.id">
    <a-button v-tc="{ name: '评价' }" @click="openEvaluation">{{ hasEvaluated ? '查看评价' : '评价' }}</a-button>
    <EvaluationModal ref="evaluationModalRef" :data-source="dataSource" @saveOk="onOk" />
  </span>
</template>

<script>
import EvaluationModal from '@/pages/business/requirement/components/EvaluationModal';
export default {
  components: { EvaluationModal },
  props: {
    dataSource: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      hasEvaluated: false, // 当前用户是否已评价
      loading: false
    };
  },
  watch: {
    dataSource: {
      handler(newVal) {
        if (newVal && newVal.id) {
          this.checkUserEvaluationStatus();
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    async checkUserEvaluationStatus() {
      if (!this.dataSource.id) return;

      try {
        this.loading = true;
        const { queryRequirementEvaluations } = await import('@/api/business/requirement');
        const res = await queryRequirementEvaluations({
          brId: this.dataSource.id,
          userId: this.$store.state.userInfo.id,
          pageNumber: 1,
          pageSize: 1
        });
        this.hasEvaluated = (res.data?.total || 0) > 0;
      } catch (error) {
        console.error('查询用户评价状态失败：', error);
        this.hasEvaluated = false;
      } finally {
        this.loading = false;
      }
    },

    openEvaluation() {
      if (this.hasEvaluated) {
        // 已评价：展示评价列表
        this.$refs.evaluationModalRef.onOpen(true);
      } else {
        // 未评价：展示评价表单
        this.$refs.evaluationModalRef.onOpen(false);
      }
    },

    onOk() {
      // 评价提交成功后，重新检查评价状态
      this.checkUserEvaluationStatus();
      this.$emit('saveOk');
    }
  }
};
</script>

<style lang="less" scoped></style>
